<template>
  <div>
    <AppNavigationTop :navigationInfo="AppNavigationTopInfo"/>
    <div class="mt-4"/>
    <!-- <v-progress-linear :indeterminate="true"></v-progress-linear> -->
    <TreeList v-if="this.tag !== 'U1'" data="{tag='K6'}"/>
    <AppNavigationBottom/>
  </div>
</template>
<script>
import AppNavigationTop from "@/frame/navigation/components/AppNavigationTop";
import TreeList from "@/asset/tree/components/TreeList";
import currentPage from "@/frame/pages/mixins/currentPage.js";
import AppNavigationBottom from "@/frame/navigation/components/AppNavigationBottom";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import { mapGetters } from "vuex";

export default {
  components: {
    AppNavigationBottom,
    AppNavigationTop,
    TreeList
    // Search
  },
  computed: {
    ...mapGetters([
      "getSearchResults",
      "getCurrentPage",
      "getPreviousPage",
      "getPageTitle",
      "getRegisterInfo"
    ]),
    tag() {
      let tag = null;
      if (this.getSearchResults !== null && this.getSearchResults.length > 0) {
        tag = this.getSearchResults[0].basic.tag;
      }
      return tag;
    },
    AppNavigationTopInfo() {
      let obj = {
        title: "Asset Tree",
        titleColour: "wplblue0--text",
        btns: [
          {
            title: "person",
            icon: "person",
            link: "/userdash"
          },
          {
            title: "sign out",
            icon: "person_outline",
            link: "/signout"
          }
        ]
      };
      if (this.tag === "A1") {
        obj.title = "Asset Tree";
        obj.btns[0].title = "Facility";
        obj.btns[0].link = "/facilitydash";
        obj.btns[0].icon = "place";
      }
      return obj;
    }
  },
  mixins: [currentPage, apptheme, storeFunctions],
  data() {
    return {
      currentPagePath: "/treeview"
    };
  },
  beforeMount() {
    this.$store.dispatch("changePreviousPage", this.getCurrentPage);
    this.$store.dispatch("changeCurrentPage", this.currentPagePath);
    this.$store.dispatch("changeCommsDialog", false);
    // Reset STORE (previous document data)
    // this.resetStoreDetail();
  },
  mounted() {
    // POssible race condiction with other logic
    this.resetStoreDetail();
  }
};
</script>
